@file:kotlin.js.JsExport
/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by omnia
 * On: 21/Jun/2026.
 */

package com.narbase.letsgo.web.routing.domain.passenger.sharedride
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.dto.currency.CurrencyDto
import com.narbase.letsgo.web.models.RideStatus
import com.narbase.letsgo.web.models.RideType
import com.narbase.letsgo.web.routing.domain.passenger.rides.DriverDetailsDto

class SharedRideDto(
    val rideId: KmmLong,
    @Suppress("NON_EXPORTABLE_TYPE") val status: DtoName<RideStatus>,
    val statusTimestamp: DateTimeDto?,

    val passengerName: String,

    val pickupAddress: String,
    val pickupLat: Double,
    val pickupLng: Double,

    val destAddress: String?,
    val destLat: Double?,
    val destLng: Double?,

    val driver: DriverDetailsDto?,

    val carType: String?,
    val currency: CurrencyDto?,
    val price: Int?,
    val discount: Double?,
    val ridePromoDiscount: Double?,

    val rideTime: DateTimeDto,
    @Suppress("NON_EXPORTABLE_TYPE") val rideType: DtoName<RideType>,

    val cancellationReason: String?,
)